import TRANSLATIONS from "../../../assets/strings/strings.json";
import { AVAILABLE_LANGUAGES } from "./translatedUrls";
import { createTranslate, TranslationKeyOf } from "@digipost/translate";

export const translator = createTranslate(
  [...AVAILABLE_LANGUAGES],
  TRANSLATIONS,
  (e) => console.log(e),
);
export type TranslationKey = TranslationKeyOf<typeof translator>;
